import React from 'react'
import { TimePicker, Tag, Typography } from 'antd'
import { IServiceSlotDay } from 'models/services'

interface SlotScheduleEditorProps {
  value?: IServiceSlotDay[]
  durationMin?: number
  onChange?: (value: IServiceSlotDay[]) => void
}

const WEEKDAYS = [
  { weekday: 1, label: 'Понедельник' },
  { weekday: 2, label: 'Вторник' },
  { weekday: 3, label: 'Среда' },
  { weekday: 4, label: 'Четверг' },
  { weekday: 5, label: 'Пятница' },
  { weekday: 6, label: 'Суббота' },
  { weekday: 7, label: 'Воскресенье' }
]

const pad = (n: number) => String(n).padStart(2, '0')

// конец = начало + длительность
const addMinutes = (time: string, minutes: number) => {
  const [h, m] = time.split(':').map(Number)
  const total = h * 60 + m + minutes
  return `${pad(Math.floor(total / 60))}:${pad(total % 60)}`
}

export const SlotScheduleEditor: React.FC<SlotScheduleEditorProps> = ({
  value = [],
  durationMin,
  onChange
}) => {
  const getTimes = (weekday: number) =>
    value.find((d) => d.weekday === weekday)?.times ?? []

  const setTimes = (weekday: number, times: string[]) => {
    const rest = value.filter((d) => d.weekday !== weekday)
    const next = times.length
      ? [...rest, { weekday, times: [...times].sort() }]
      : rest
    onChange?.(next.sort((a, b) => a.weekday - b.weekday))
  }

  const addTime = (weekday: number, time: string) => {
    const times = getTimes(weekday)
    if (times.includes(time)) return
    setTimes(weekday, [...times, time])
  }

  const removeTime = (weekday: number, time: string) => {
    setTimes(
      weekday,
      getTimes(weekday).filter((t) => t !== time)
    )
  }

  return (
    <div style={{ border: '1px solid #f0f0f0', borderRadius: 8 }}>
      {!durationMin && (
        <Typography.Text
          type='warning'
          style={{ display: 'block', padding: '8px 12px' }}
        >
          Укажите длительность занятия, чтобы рассчитывалось время окончания
          слотов
        </Typography.Text>
      )}
      {WEEKDAYS.map(({ weekday, label }) => (
        <div
          key={weekday}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '10px 12px',
            borderTop: '1px solid #f0f0f0'
          }}
        >
          <div style={{ width: 130, flexShrink: 0, fontWeight: 500 }}>
            {label}
          </div>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 8,
              alignItems: 'center',
              flex: 1
            }}
          >
            {getTimes(weekday).map((time) => (
              <Tag
                key={time}
                closable
                onClose={() => removeTime(weekday, time)}
                color='blue'
              >
                {time}
                {durationMin ? ` – ${addMinutes(time, durationMin)}` : ''}
              </Tag>
            ))}
            <TimePicker
              format='HH:mm'
              minuteStep={5}
              placeholder='+ слот'
              value={null}
              size='small'
              style={{ width: 110 }}
              onChange={(v) => v && addTime(weekday, v.format('HH:mm'))}
            />
          </div>
        </div>
      ))}
    </div>
  )
}
